import { requireService } from '@profgeosoft/di-ez';
import { clsx } from 'clsx';
import { useNavigate } from 'react-router-dom';

import { wrap } from 'src/packages/mobx-di/wrap';
import { hasValue } from 'src/packages/utils/has-value';

import type { TModelOption } from '../directory-model-service';

import styles from '../models-list.module.scss';

type Props = {
  model: TModelOption;
};

export const ModelsListItem = wrap<Props>(function ModelsListItem({ model }) {
  const navigate = useNavigate();
  const directoryPage = requireService('directoryPage');
  const { directoryModelService } = directoryPage;

  const { label, value } = model;
  const isActive = value === directoryModelService?.currentModelId;
  const errorCount = directoryModelService?.errorsCountByModelId[value];

  const onModelClick = () => {
    if (value === directoryModelService?.currentModelId) {
      return;
    }

    const isNewModelSet = directoryModelService?.setCurrentModel(value);

    if (isNewModelSet) {
      navigate(value.toString());
    }
  };

  return (
    <li>
      <button className={clsx(styles.listButton, isActive && styles.listButton_active)} onClick={onModelClick}>
        <p className={styles.listButton_text} title={label}>
          {label}
        </p>
        {hasValue(errorCount) && errorCount > 0 && <div className={styles.errorInfo}>{errorCount}</div>}
      </button>
    </li>
  );
});
